module.exports = __webpack_public_path__ + "img/grand_mosque.8feb04fc.png";